export default "__VITE_ASSET__BvIC6NJm__"